/* eslint no-console: "off" */
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';

let gameStompClient = null;
let gameBalanceStompClient = null;
let notificationsStompClient = null;

const createNewStompClient = (path) => {
  console.log('creating a new web socket client');
  const newGameSocket = new SockJS(path);
  const stompClient = Stomp.over(newGameSocket);
  if (path === '/gameData') {
    gameStompClient = stompClient;
  } else if (path === '/gameBalanceData') {
    gameBalanceStompClient = stompClient;
  } else if (path === '/notificationsData') {
    notificationsStompClient = stompClient;
  }
  // TODO uncomment following line in live builds in order to disable/remove debug messages
  stompClient.debug = null;
  return stompClient;
};

const getGameStompClient = () => gameStompClient;
const getGameBalanceStompClient = () => gameBalanceStompClient;
const getNotificationsStompClient = () => notificationsStompClient;

const disconnectStompClient = stompClient => new Promise((resolve, reject) => {
  if (stompClient === null) {
    reject(Error('Stomp client is already disconnected'));
  } else if (stompClient.connected) {
    stompClient.disconnect(() => {
      resolve('Stomp client disconnected');
    });
  }
});

export default {
  createNewStompClient,
  getGameStompClient,
  getGameBalanceStompClient,
  getNotificationsStompClient,
  disconnectStompClient,
};



// WEBPACK FOOTER //
// ./src/common/webSocket.js